export default __webpack_public_path__ + "static/media/icon-breadcrumb-right.f0bc9767.svg";